import React from "react";
import styles from "./Style.module.css";

export const VerificationMethodPanel = ({
  title = "Send OTP",
  resendCountdown,
  disabled = false,
  onSelect,
}) => {
  const remainingSeconds = Math.max(0, Math.ceil(Number(resendCountdown) || 0));
  const countdownLabel = `${String(Math.floor(remainingSeconds / 60)).padStart(2, "0")}:${String(remainingSeconds % 60).padStart(2, "0")}`;
  const panelTitle = remainingSeconds > 0
    ? `${title} in ${countdownLabel}`
    : title;

  return (
    <section className={styles.deliveryPanel} aria-label="Send OTP">
      <div className={styles.deliveryActions}>
        <button
          type="button"
          className={`${styles.deliveryButton} ${styles.smsButton}`}
          onClick={() => onSelect?.("sms")}
          disabled={disabled || remainingSeconds > 0}
          aria-label={`${panelTitle} via SMS`}
        >
          <span>{panelTitle}</span>
        </button>
      </div>
    </section>
  );
};

export default VerificationMethodPanel;
